import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentcolor",
      "fill-rule": "evenodd",
      d: "m15.009 15.79-4.407-3.985a1.273 1.273 0 0 0-1.746.036 1.13 1.13 0 0 0 .035 1.644l5.448 4.91a1 1 0 0 0 1.34 0l5.43-4.909a1.13 1.13 0 0 0 .035-1.645 1.27 1.27 0 0 0-1.744-.035z"
    }, null, -1)
  ]))]))
}
export default { render: render }